/* Umbremo front-end. Dual-mode cart + page interactions.
   Static preview: a local cart kept in localStorage. Theme mode (window.UM_THEME): native Shopify cart AJAX. */
(function () {
  "use strict";

  var THEME = !!window.UM_THEME;
  var ASSET = window.UM_ASSET_BASE || "assets/";
  var CART_KEY = "umCart";
  var PRICE = 39.99;
  var TYPE = "Umbrella";
  var PROTECT = window.UM_PROTECT || null;
  var POUCH = window.UM_POUCH || null; // {id, price} printed by Liquid from the pouch product // {id, price} printed by Liquid from the hidden protection product
  var money = function (v) { return "$" + (Math.round(v * 100) / 100).toFixed(2); };

  var COLORS = [
    ["black", "Black", "#3A3A3C"], ["beige", "Beige", "#D2C5BC"], ["blue", "Blue", "#64709A"],
    ["gray", "Gray", "#8C8B90"], ["pink", "Pink", "#CBADC7"], ["green", "Green", "#B4C6BA"]
  ];
  var HEX = {}, NAME = {}, SLUG_BY_NAME = {};
  COLORS.forEach(function (c) { HEX[c[0]] = c[2]; NAME[c[0]] = c[1]; SLUG_BY_NAME[c[1].toLowerCase()] = c[0]; });

  // bundle ladder: min qty, dollars off, discount code
  // flat amounts, once per order: the same maths Shopify runs at checkout, so the drawer can never disagree with it
  var LADDER = [{ min: 3, off: 18, code: "BUNDLE3" }, { min: 2, off: 8, code: "BUNDLE2" }];
  function rung(q) { for (var i = 0; i < LADDER.length; i++) if (q >= LADDER[i].min) return LADDER[i]; return null; }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  // ---------------------------------------------------------- products
  // Theme mode: window.UM_PRODUCT is printed by Liquid from the live product (never hardcoded ids).
  var PRODUCT = window.UM_PRODUCT || {
    title: "Umbremo Automatic Folding Umbrella", handle: "umbremo-automatic-folding-umbrella",
    variants: COLORS.map(function (c) { return { id: "local-" + c[0], title: c[1], price: PRICE }; })
  };
  function variantFor(slug) {
    return PRODUCT.variants.filter(function (v) { return String(v.title).toLowerCase() === NAME[slug].toLowerCase(); })[0];
  }

  // ---------------------------------------------------------- cart backends
  function localRead() {
    try { return JSON.parse(localStorage.getItem(CART_KEY) || "[]"); } catch (e) { return []; }
  }
  function localWrite(lines) {
    try { localStorage.setItem(CART_KEY, JSON.stringify(lines)); } catch (e) {}
    return Promise.resolve({ lines: lines });
  }
  var backend = {
    fetch: function () { return Promise.resolve({ lines: localRead() }); },
    add: function (items) {
      var lines = localRead();
      items.forEach(function (it) {
        var hit = lines.filter(function (l) { return l.lineId === String(it.id); })[0];
        if (hit) hit.qty += it.quantity;
        else {
          var v = PRODUCT.variants.filter(function (x) { return String(x.id) === String(it.id); })[0];
          lines.push({ lineId: String(it.id), qty: it.quantity, variant: v.title, price: v.price, title: PRODUCT.title, type: TYPE });
        }
      });
      return localWrite(lines);
    },
    change: function (lineId, qty) {
      var lines = localRead().filter(function (l) { if (l.lineId === lineId) l.qty = qty; return l.qty > 0; });
      return localWrite(lines);
    }
  };

  if (THEME) {
    var mapNative = function (c) {
      return { lines: (c.items || []).map(function (it) {
        return { lineId: String(it.key), qty: it.quantity, variant: it.variant_title || "",
                 price: it.price / 100, title: it.product_title, type: it.product_type,
                 image: it.image };
      }) };
    };
    var nativeJson = function (url, body) {
      return fetch(url, {
        method: body ? "POST" : "GET",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) {
        if (!r.ok) throw new Error("cart request failed " + r.status);
        return r.json();
      });
    };
    backend = {
      fetch: function () { return nativeJson("/cart.js").then(mapNative); },
      add: function (items) { return nativeJson("/cart/add.js", { items: items }).then(function () { return backend.fetch(); }); },
      change: function (lineId, qty) { return nativeJson("/cart/change.js", { id: lineId, quantity: qty }).then(mapNative); }
    };
  }

  // ---------------------------------------------------------- cart logic
  var cart = { lines: [] };

  function umbrellaLines() { return cart.lines.filter(function (l) { return l.type === TYPE; }); }
  function umbrellaQty() { return umbrellaLines().reduce(function (a, l) { return a + l.qty; }, 0); }

  function imgFor(line) {
    if (line.type === "Protection") return null;
    if (line.type === "Pouch") return ASSET + "um-pouch-480.webp";
    var slug = SLUG_BY_NAME[String(line.variant).toLowerCase()];
    if (slug) return ASSET + "um-" + slug + "-480.webp";
    return line.image || (ASSET + "um-black-480.webp");
  }

  function renderCart() {
    var root = $("[data-cart]");
    if (!root) return;
    // umbrellas first, protection last, whatever order Shopify returns them in
    var rank = function (l) { return l.type === "Protection" ? 2 : l.type === "Pouch" ? 1 : 0; };
    var lines = cart.lines.slice().sort(function (a, b) { return rank(a) - rank(b); });
    var count = lines.reduce(function (a, l) { return a + l.qty; }, 0);

    var badge = $("[data-cart-count]");
    if (badge) { badge.textContent = count; badge.hidden = count === 0; }
    $("[data-cart-empty]").hidden = count > 0;
    $("[data-cart-foot]").hidden = count === 0;

    var box = $("[data-cart-lines]");
    box.innerHTML = "";
    lines.forEach(function (l) {
      var row = document.createElement("div");
      row.className = "um-line";
      row.innerHTML =
        (imgFor(l) ? '<img src="' + imgFor(l) + '" width="72" height="72" alt="">' : '<span class="um-line__ic">' + $("[data-protect] .um-protect__ic").innerHTML + '</span>') +
        '<span><span class="um-line__t">' + (l.type === "Protection" ? "Shipping Protection" : l.type === "Pouch" ? "Drip-Free Microfiber Pouch" : "Umbremo Umbrella") + "</span>" +
        (l.variant && l.variant !== "Default Title" ? '<span class="um-line__v">' + l.variant + "</span>" : "") +
        (l.type === "Protection" ? "" : '<span class="um-line__qty"><button type="button" data-dec aria-label="Decrease quantity">&minus;</button><span>' + l.qty + '</span><button type="button" data-inc aria-label="Increase quantity">+</button></span>') + "</span>" +
        '<span><span class="um-line__p">' + money(l.price * l.qty) + '</span><button class="um-line__rm" type="button" data-rm>Remove</button></span>';
      if (l.type !== "Protection") {
        row.querySelector("[data-inc]").addEventListener("click", function () { changeQty(l, l.qty + 1); });
        row.querySelector("[data-dec]").addEventListener("click", function () { changeQty(l, l.qty - 1); });
      }
      row.querySelector("[data-rm]").addEventListener("click", function () { changeQty(l, 0); });
      box.appendChild(row);
    });

    var q = umbrellaQty();
    var nudge = $("[data-cart-nudge]");
    if (q === 1 || q === 2) {
      nudge.hidden = false;
      $("[data-cart-nudge-text]").textContent = q === 1
        ? "Add a second umbrella and save $8."
        : "Add a third and save $18 in total.";
    } else nudge.hidden = true;

    var pouchRow = $("[data-pouch]");
    if (pouchRow) {
      var inCart = cart.lines.some(function (l) { return l.type === "Pouch"; });
      pouchRow.hidden = !(q > 0 && POUCH && !inCart);
      var pb = $("[data-pouch-btn]"); if (pb) { pb.disabled = false; pb.textContent = "Add"; }
    }

    var prot = $("[data-protect]");
    if (prot) {
      var pLine = cart.lines.filter(function (l) { return l.type === "Protection"; })[0];
      prot.hidden = !(q > 0 && (PROTECT || pLine));
      var box = $("[data-protect-toggle]");
      if (box) box.checked = !!pLine;
    }

    var uSub = umbrellaLines().reduce(function (a, l) { return a + l.price * l.qty; }, 0);
    var subtotal = lines.reduce(function (a, l) { return a + l.price * l.qty; }, 0);
    var r = rung(q);
    var sv = r ? Math.min(r.off, uSub) : 0;
    var protLine = cart.lines.filter(function (l) { return l.type === "Protection"; })[0];
    if (protLine && subtotal) subtotal = subtotal; // protection is a normal paid line, shown in the subtotal
    $("[data-cart-savings]").hidden = !sv;
    if (sv) $("[data-cart-savings-amt]").textContent = "−" + money(sv);
    $("[data-cart-subtotal]").textContent = money(subtotal - sv);
  }

  function busy(el, on) { if (!el) return; el.disabled = on; el.style.opacity = on ? ".55" : ""; }

  // Optimistic + queued: the drawer updates the instant you tap, requests go out one at a time, and the
  // server's answer is only painted once nothing else is waiting, so fast double taps are never lost.
  var cartQueue = Promise.resolve(), cartPending = 0;
  function changeQty(line, qty) {
    qty = Math.max(0, qty);
    if (line.type === TYPE && qty === 0 && umbrellaQty() - line.qty <= 0) {
      cart.lines.filter(function (l) { return l.type === "Protection" || l.type === "Pouch"; }).forEach(function (x) { changeQty(x, 0); });
    }
    cart.lines = cart.lines.filter(function (l) { if (l.lineId === line.lineId) l.qty = qty; return l.qty > 0; });
    renderCart();
    cartPending++;
    cartQueue = cartQueue.then(function () { return backend.change(line.lineId, qty); })
      .then(function (c) { cartPending--; if (cartPending === 0 && c) { cart = c; renderCart(); } })
      .catch(function () { cartPending--; if (cartPending === 0) syncCart(); });
  }

  var pouchBtn = $("[data-pouch-btn]");
  if (pouchBtn) pouchBtn.addEventListener("click", function () {
    if (!POUCH || pouchBtn.disabled) return;
    pouchBtn.disabled = true; pouchBtn.textContent = "Adding\u2026";
    backend.add([{ id: POUCH.id, quantity: 1 }]).then(function (c) { cart = c; renderCart(); }).catch(function () { pouchBtn.disabled = false; pouchBtn.textContent = "Add"; syncCart(); });
  });

  var protectBox = $("[data-protect-toggle]");
  if (protectBox) protectBox.addEventListener("change", function () {
    var pLine = cart.lines.filter(function (l) { return l.type === "Protection"; })[0];
    if (protectBox.checked && !pLine && PROTECT) {
      backend.add([{ id: PROTECT.id, quantity: 1 }]).then(function (c) { cart = c; renderCart(); }).catch(syncCart);
    } else if (!protectBox.checked && pLine) {
      changeQty(pLine, 0);
    }
  });

  var nudgeBtn = $("[data-cart-nudge-add]");
  if (nudgeBtn) nudgeBtn.addEventListener("click", function () {
    var first = umbrellaLines()[0];
    if (first) changeQty(first, first.qty + 1);
  });

  function lock(on) { document.documentElement.style.overflow = on ? "hidden" : ""; }
  function openPanel(root) {
    if (!root) return;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add("is-open"); });
    lock(true);
  }
  function closePanel(root) {
    if (!root || root.hidden) return;
    root.classList.remove("is-open");
    lock(false);
    setTimeout(function () { root.hidden = true; }, 300);
  }
  var openCart = function () { openPanel($("[data-cart]")); };
  var closeCart = function () { closePanel($("[data-cart]")); };
  var openMenu = function () { openPanel($("[data-drawer]")); };
  var closeMenu = function () { closePanel($("[data-drawer]")); };

  function checkout() {
    var btn = $("[data-cart-checkout]");
    var r = rung(umbrellaQty());
    if (THEME) {
      busy(btn, true);
      window.location.href = r ? "/discount/" + r.code + "?redirect=%2Fcheckout" : "/checkout";
      return;
    }
    var note = $("[data-cart-preview-note]");
    if (note) { note.hidden = false; note.textContent = "Preview build. Checkout goes live once the theme is on your Shopify store" + (r ? " (code " + r.code + " will apply)." : "."); }
  }

  $$("[data-drawer-open]").forEach(function (b) { b.addEventListener("click", openMenu); });
  $$("[data-drawer-close]").forEach(function (b) { b.addEventListener("click", closeMenu); });
  $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", openCart); });
  $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeCart); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeMenu(); closeCart(); } });
  var co = $("[data-cart-checkout]");
  if (co) co.addEventListener("click", checkout);

  // ---------------------------------------------------------- reveal
  if (document.documentElement.className.indexOf("js-anim") !== -1 && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -6% 0px" });
    $$(".um-rise").forEach(function (el) { io.observe(el); });
  } else {
    $$(".um-rise").forEach(function (el) { el.classList.add("is-in"); });
  }

  // ---------------------------------------------------------- reviews pager
  var pager = $("[data-rv-pager]");
  if (pager) {
    var rvCards = $$("[data-rv-card]"), size = +pager.getAttribute("data-size"), pages = +pager.getAttribute("data-pages"), page = 1;
    var drawPager = function (scroll) {
      rvCards.forEach(function (c, i) { c.hidden = Math.floor(i / size) + 1 !== page; });
      var html = '<button type="button" data-p="prev" aria-label="Previous page"' + (page === 1 ? " disabled" : "") + ">&larr;</button>";
      for (var p = 1; p <= pages; p++) html += '<button type="button" data-p="' + p + '" aria-current="' + (p === page) + '">' + p + "</button>";
      html += '<button type="button" data-p="next" aria-label="Next page"' + (page === pages ? " disabled" : "") + ">&rarr;</button>";
      pager.innerHTML = html;
      if (scroll) $("#reviews").scrollIntoView({ behavior: "smooth", block: "start" });
    };
    pager.addEventListener("click", function (e) {
      var b = e.target.closest("button"); if (!b || b.disabled) return;
      var v = b.getAttribute("data-p");
      page = v === "prev" ? page - 1 : v === "next" ? page + 1 : +v;
      drawPager(true);
    });
    drawPager(false);
  }

  // ---------------------------------------------------------- videos
  var vids = $$("[data-vid]");
  if (vids.length) {
    var loud = null;
    var setLoud = function (card, on) {
      var v = $("video", card);
      v.muted = !on;
      card.classList.toggle("is-loud", on);
      if (on) { if (loud && loud !== card) setLoud(loud, false); loud = card; }
      else if (loud === card) loud = null;
    };
    var load = function (card) {
      var v = $("video", card);
      if (!v.getAttribute("src")) { v.src = v.getAttribute("data-src"); }
      return v;
    };
    vids.forEach(function (card) {
      var v = $("video", card), bar = $("[data-vid-bar]", card);
      v.addEventListener("playing", function () { card.classList.add("is-playing"); });
      v.addEventListener("pause", function () { card.classList.remove("is-playing"); });
      v.addEventListener("timeupdate", function () {
        if (v.duration) bar.style.width = (v.currentTime / v.duration * 100) + "%";
      });
      var hasAudio = card.getAttribute("data-audio") === "1";
      card.addEventListener("click", function () {
        load(card);
        if (!hasAudio) { if (v.paused) v.play().catch(function () {}); else v.pause(); return; }
        if (v.paused) { setLoud(card, true); v.play().catch(function () {}); }
        else setLoud(card, v.muted);
      });
    });
    if ("IntersectionObserver" in window) {
      var still = (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) || /[?&]still=1/.test(location.search);
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var card = en.target, v = $("video", card);
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            if (still) return;
            load(card);
            v.play().catch(function () {});
          } else if (!v.paused) {
            v.pause();
            if (loud === card) setLoud(card, false);
          }
        });
      }, { threshold: [0, 0.6] });
      vids.forEach(function (c) { vio.observe(c); });
    }
  }

  // ---------------------------------------------------------- PDP
  var buy = $("[data-buy]");
  if (buy) {
    var TIERS = { 1: 39.99, 2: 71.98, 3: 101.97 };
    var slotTpl = $("[data-slot-template]");
    var currentColor = "black";

    var selectedTier = function () {
      var r = $("[data-tier]:checked");
      return r ? parseInt(r.value, 10) : 2;
    };
    var slotsBoxFor = function (n) { return $('[data-slots="' + n + '"]'); };

    var showImg = function (key) {
      $$("[data-gal-img]").forEach(function (im) { im.hidden = im.getAttribute("data-gal-img") !== key; });
      $$("[data-gal-thumb]").forEach(function (t) {
        var on = t.getAttribute("data-gal-thumb") === key;
        t.setAttribute("aria-selected", String(on));
        // keep the active thumb visible inside the mobile strip without moving the page
        var strip = t.parentNode;
        if (on && strip.scrollWidth > strip.clientWidth) {
          strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: "smooth" });
        }
      });
    };
    var paintDots = function () {
      $$(".um-slot").forEach(function (s) {
        $("[data-slot-dot]", s).style.background = HEX[$("[data-slot-color]", s).value];
      });
    };
    var showColor = function (slug, keepImage) {
      currentColor = slug;
      if (!keepImage) showImg("um-" + slug);
      var first = $("[data-slot-color]", slotsBoxFor(selectedTier()));
      if (first && first.value !== slug) first.value = slug;
      paintDots();
    };

    var renderSlots = function (n) {
      $$("[data-slots]").forEach(function (box) {
        if (+box.getAttribute("data-slots") !== n) box.innerHTML = "";
      });
      var box = slotsBoxFor(n);
      for (var i = $$(".um-slot", box).length; i < n; i++) {
        var node = slotTpl.content.firstElementChild.cloneNode(true);
        var sel = node.querySelector("[data-slot-color]");
        // first slot follows the gallery colour; extra slots start on the next colours so a bundle reads as a mix
        var idx = COLORS.map(function (c) { return c[0]; }).indexOf(currentColor);
        sel.value = COLORS[(idx + i) % COLORS.length][0];
        box.appendChild(node);
      }
      $$(".um-slot", box).forEach(function (s, k) { $("[data-slot-label]", s).textContent = "#" + (k + 1); });
      paintDots();
    };

    var updatePrice = function () {
      var total = TIERS[selectedTier()];
      $("[data-cta-price]").textContent = money(total);
      var sp = $("[data-sticky-price]");
      if (sp) sp.textContent = money(total);
    };

    // one delegated listener covers server-rendered and script-rendered pickers alike
    buy.addEventListener("change", function (e) {
      if (!e.target.matches || !e.target.matches("[data-slot-color]")) return;
      var slots = $$(".um-slot", slotsBoxFor(selectedTier()));
      if (slots.length && slots[0].contains(e.target)) showColor(e.target.value);
      paintDots();
    });

    $$("[data-gal-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        var slug = t.getAttribute("data-color-slug");
        if (slug) showColor(slug); else showImg(t.getAttribute("data-gal-thumb"));
      });
    });
    $$("[data-tier]").forEach(function (r) {
      r.addEventListener("change", function () { renderSlots(selectedTier()); updatePrice(); });
    });

    // deep links: ?color=slug & ?qty=n. Without ?color the gallery opens on the first image.
    var qc = null;
    try {
      var params = new URLSearchParams(location.search);
      qc = params.get("color");
      var qq = parseInt(params.get("qty") || "", 10);
      if (qq >= 1 && qq <= 3) { var radio = $('[data-tier][value="' + qq + '"]'); if (radio) radio.checked = true; }
      if (!qc && params.get("variant") && window.UM_PRODUCT) {
        var pv = PRODUCT.variants.filter(function (v) { return String(v.id) === params.get("variant"); })[0];
        if (pv) qc = SLUG_BY_NAME[String(pv.title).toLowerCase()];
      }
    } catch (e) {}
    if (qc && HEX[qc]) { currentColor = qc; renderSlots(selectedTier()); showColor(qc); }
    else { renderSlots(selectedTier()); showColor("black", true); }
    updatePrice();

    var addToCart = function () {
      var btn = $("[data-add-to-cart]"), err = $("[data-cart-error]");
      err.hidden = true;
      var want = {};
      $$(".um-slot", slotsBoxFor(selectedTier())).forEach(function (s) {
        var v = variantFor($("[data-slot-color]", s).value);
        if (v) want[v.id] = (want[v.id] || 0) + 1;
      });
      var items = Object.keys(want).map(function (id) { return { id: THEME ? parseInt(id, 10) : id, quantity: want[id] }; });
      if (!items.length) {
        err.textContent = "That color is not available right now. Try another one.";
        err.hidden = false;
        return;
      }
      var btns = [btn, $("[data-sticky-go]")].filter(Boolean);
      var label = function (on) {
        btns.forEach(function (b) {
          if (on) { b.setAttribute("data-label", b.innerHTML); b.textContent = "Adding\u2026"; }
          else if (b.hasAttribute("data-label")) { b.innerHTML = b.getAttribute("data-label"); b.removeAttribute("data-label"); }
          busy(b, on);
        });
      };
      if (btn.disabled) return;
      // Shipping protection is opt-in: it is only added when the shopper ticks it in the cart.
      label(true);
      backend.add(items).then(function (c) {
        cart = c; label(false); updatePrice(); renderCart(); openCart();
      }).catch(function () {
        label(false);
        err.textContent = "Could not reach the store just now. Give it a second and try again.";
        err.hidden = false;
      });
    };
    $("[data-add-to-cart]").addEventListener("click", addToCart);
    var sg = $("[data-sticky-go]");
    if (sg) sg.addEventListener("click", addToCart);

    // lightbox: click the main image to zoom, arrows / keys to move
    var lb = $("[data-lb]");
    if (lb) {
      var keys = $$("[data-gal-thumb]").map(function (t) { return t.getAttribute("data-gal-thumb"); });
      var cur = 0;
      var lbShow = function (i) {
        cur = (i + keys.length) % keys.length;
        var src = $('[data-gal-img="' + keys[cur] + '"]');
        var big = $("[data-lb-img]");
        big.src = src.getAttribute("src"); big.alt = src.alt;
      };
      var lbClose = function () { lb.classList.remove("is-open"); lock(false); setTimeout(function () { lb.hidden = true; }, 250); };
      $("[data-gal-zoom]").addEventListener("click", function () {
        var vis = $$("[data-gal-img]").filter(function (im) { return !im.hidden; })[0];
        lbShow(keys.indexOf(vis.getAttribute("data-gal-img")));
        lb.hidden = false; lock(true);
        requestAnimationFrame(function () { lb.classList.add("is-open"); });
      });
      $("[data-lb-close]").addEventListener("click", lbClose);
      $("[data-lb-prev]").addEventListener("click", function (e) { e.stopPropagation(); lbShow(cur - 1); });
      $("[data-lb-next]").addEventListener("click", function (e) { e.stopPropagation(); lbShow(cur + 1); });
      lb.addEventListener("click", function (e) { if (e.target === lb) lbClose(); });
      document.addEventListener("keydown", function (e) {
        if (lb.hidden) return;
        if (e.key === "Escape") lbClose();
        if (e.key === "ArrowLeft") lbShow(cur - 1);
        if (e.key === "ArrowRight") lbShow(cur + 1);
      });
    }

    // sticky bar: on only after the main button has scrolled above the screen (scroll-driven, so jumps and anchor links stay correct)
    var sticky = $("[data-sticky]"), mainBtn = $("[data-add-to-cart]");
    if (sticky) {
      var ticking = false;
      var syncSticky = function () {
        ticking = false;
        sticky.classList.toggle("is-on", mainBtn.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener("scroll", function () {
        if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); }
      }, { passive: true });
      syncSticky();
    }
  }

  // ---------------------------------------------------------- load cart
  var syncCart = function () { return backend.fetch().then(function (c) { cart = c; renderCart(); }).catch(function () {}); };
  syncCart();
  // Back / forward restores a frozen copy of the page: close any open panel and re-read the cart so the count is never stale
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    closeCart(); closeMenu(); lock(false);
    $$("[data-add-to-cart],[data-sticky-go],[data-cart-checkout]").forEach(function (b) {
      if (b.hasAttribute("data-label")) { b.innerHTML = b.getAttribute("data-label"); b.removeAttribute("data-label"); }
      busy(b, false);
    });
    syncCart();
  });

  // warm the next page the moment a finger or cursor lands on an internal link
  var warmed = {};
  var warm = function (e) {
    var a = e.target.closest && e.target.closest("a[href]");
    if (!a || a.origin !== location.origin || warmed[a.pathname] || a.pathname === location.pathname) return;
    warmed[a.pathname] = 1;
    var l = document.createElement("link"); l.rel = "prefetch"; l.href = a.pathname + a.search; document.head.appendChild(l);
  };
  document.addEventListener("touchstart", warm, { passive: true });
  document.addEventListener("mouseover", warm, { passive: true });

  // ---------------------------------------------------------- forms (static preview only; the theme uses native Shopify forms)
  function wireCapture(formSel, noteSel) {
    var f = $(formSel);
    if (!f) return;
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var input = f.querySelector("input[type=email]"), note = $(noteSel);
      var ok = input.value && input.value.indexOf("@") > 0;
      note.textContent = ok ? "You're on the list. Talk soon." : "That email looks off. One more try?";
      note.hidden = false;
      if (ok) input.value = "";
    });
  }
  wireCapture("[data-capture]", "[data-capture-note]");
  wireCapture("[data-capture-2]", "[data-capture-2-note]");

  var contact = $("[data-contact]");
  if (contact) {
    contact.addEventListener("submit", function (e) {
      e.preventDefault();
      var fd = new FormData(contact), note = $("[data-contact-note]");
      var ok = fd.get("name") && fd.get("email") && fd.get("message");
      note.textContent = ok ? "Thanks. A real person answers within one business day."
                            : "Fill in your name, email and message and we take it from there.";
      note.hidden = false;
      if (ok) contact.reset();
    });
  }
})();
